<template>
  <div></div>
</template>

<script>

  export default {
    data () {
      return {
      }
    },
    created () {
      // this.$route.query.key
      // '5e9ae8a2006a4f0291003edd' 5e9e4d76007cd8783b003b0f
      this.$router.push({
        name: 'formInput',
        query: {
          key: this.$route.query.key
        }
      })
    }
  }
</script>

<style lang="less">
</style>
